import * as FileHelper from './file';
const Helper = {
  file: FileHelper
};

export default Helper;
